import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { PermitStep } from "@ha/data/basic";
import { HaModalService } from "@ha/ui/common";
import { Select, Store } from "@ngxs/store";
import { Observable } from "rxjs";

import { CurrentStep } from "../../../permit/models/current-step.model";
import { PermitStepSelectors } from "../../../permit/states/permit-step.selectors";
import { PermitDetailsActions } from "../../states/permit-details.action";
import { PermitDetailsSelectors } from "../../states/permit-details.selectors";
import { PermitLogsDto } from "../../models/permit-logs-dto";

@Component({
    selector: "pmt-permit-logs",
    templateUrl: "permit-logs.component.html",
    styleUrls: ["permit-logs.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class PermitLogsComponent implements OnInit {
    @Input() public permitId: number;

    @Select(PermitDetailsSelectors.logs)
    public logs$: Observable<PermitLogsDto>;

    @Select(PermitStepSelectors.currentStep)
    public currentStep$: Observable<CurrentStep>;

    @Select(PermitDetailsSelectors.currentUserIsObserver)
    public currentUserIsObserver$: Observable<boolean>;

    public PermitStep = PermitStep;

    public avatarId: number;

    constructor(private store: Store) {}

    public ngOnInit(): void {
        this.store.dispatch(new PermitDetailsActions.GetLogs(this.permitId, false));
    }
}
